import { PureComponent, ReactNode } from 'react';
import { PAD_V2_CONTAINER } from '../PadContainer';
import MedicalRecordsRightPanel from '../../../../../pages/MedicalRecordsRightPanel';
import { MY_RECORDS } from '../../../../../pages/MedicalRecordsSwitchPanel';
import { GlobalState } from '../../../../../store/reducers';
import { batch, connect } from 'react-redux';
import { getPatient } from '../../../../../store/selectors/prescriptionPad';
import { LabVitalEntity, Patient } from '../../../../../store/types/prescription';
import { track } from '../../../../../tracking';
import { ThunkDispatch } from 'redux-thunk';
import { Actions } from '../../../../../store/actions';
import { upsertLabVital } from '../../../../../store/actions/prescriptionPad';
import { notification } from 'antd';

interface Props {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    patient?: Patient;
}

class PPMedicalRecords extends PureComponent<Props> {
    copyToPrescription = (labVitals: LabVitalEntity[]) => {
        track('COPY_SMART_VITALS_TO_RX', { from: 'prescription-pad-medical-records' });

        const { dispatch } = this.props;
        batch(() => {
            labVitals.forEach((l) => dispatch(upsertLabVital(l)));

            notification.success({
                message: `Copied to Prescription`,
                duration: 5,
            });
        });
        return;
    };

    render(): ReactNode {
        const { patient } = this.props;
        const { copyToPrescription } = this;
        const patientId = patient?.localId || patient?.id || '';
        if (!patientId) {
            return null;
        }

        return (
            <div
                className="p-16 w-full h-full flex flex-col space-y-12 overflow-hidden"
                id={PAD_V2_CONTAINER}
            >
                <MedicalRecordsRightPanel
                    plId={patientId}
                    background="#FFF"
                    activeTab={MY_RECORDS}
                    hideSwitchPanel
                    copyToPrescription={copyToPrescription}
                    hideABHACta
                />
            </div>
        );
    }
}

export default connect((state: GlobalState) => ({
    patient: getPatient(state),
}))(PPMedicalRecords);
